import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { GetIndentFormList, IndentProfile } from "../../Repository/Api";
import { errorMsg } from "../Toastify";

const IndentApplication = () => {
  const { first_name, last_name, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const navigate = useNavigate();

  const [indentList, setIndentList] = useState([]);
  // console.log(indentList)
  useEffect(() => {
    getIndentList();
  }, []);

  const getIndentList = async () => {
    const response = await GetIndentFormList(token);
    if (response && response.statusCode === 200) {
      setIndentList(response?.data?.purchase_history);
    } else {
      errorMsg(response.message);
    }
  };

  const [active, setActive] = useState(0);
  const links = ["Requested", "Partially Approved", "Approved", "Rejected"];
  const showSelected = (index) => {
    setActive(index);
  };

  const requestIndentLength = indentList.filter(
    (item) => item.status === "requested"
  ).length;
  const partialapprovedIndentLength = indentList.filter(
    (item) => item.status === "partially_approved"
  ).length;
  const approvedIndentLength = indentList.filter(
    (item) => item.status === "approved"
  ).length;
  const rejectedIndentLength = indentList.filter(
    (item) => item.status === "rejected"
  ).length;

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6 p-0">
                <h6 className="headertext">{first_name + ' ' + last_name}</h6>
              </div>
              <div className="col-lg-6 p-0">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => {
                      navigate("/app/Indent/IndentForm");
                    }}
                  >
                    Apply For New Indent
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <div className="row">
                  <div className="col-lg-4">
                    <h6 className="labeltitle">Indent Form Request Status</h6>
                  </div>
                  <div className="col-lg-6">
                    <ul className="searchtopflex">
                      {links.map((link, index) => {
                        return (
                          <li
                            onClick={() => showSelected(index)}
                            key={link}
                            className={
                              active === index
                                ? "agenttextactive"
                                : "agenttextinactive"
                            }
                          >
                            {link}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
                <div className="scroll-table">
                  <table className="table table-hover mt-5">
                    <thead>
                      <tr>
                        <th scope="col">Indent No</th>
                        <th scope="col">Name</th>
                        <th scope="col">Department</th>
                        <th scope="col">Date</th>
                        <th scope="col">Hod Status</th>
                        <th scope="col">Director Status</th>
                        <th scope="col">Application</th>
                      </tr>
                    </thead>
                    {active === 0 && (
                      <tbody>
                        {requestIndentLength > 0 ? (
                          indentList &&
                          indentList
                            ?.filter(
                              (indentList) => indentList.status === "requested"
                            )
                            .map((indent, index) => (
                              <tr key={index}>
                                <td>
                                  {indent?.indent_number
                                    ? indent?.indent_number
                                    : "-"}
                                </td>
                                <td>
                                  {indent?.employee_name
                                    ? indent?.employee_name
                                    : "-"}
                                </td>
                                <td>
                                  {indent?.department
                                    ? indent?.department
                                    : "-"}
                                </td>
                                <td>
                                  {moment(indent?.requested_date).format(
                                    "DD MMM YY"
                                  )}
                                </td>
                                <td
                                  className={
                                    indent?.hod_status === "approved"
                                      ? "till-active"
                                      : "not-active-wait" &&
                                        indent?.hod_status === "rejected"
                                        ? "not-active"
                                        : "not-active-wait"
                                  }
                                >
                                  {indent?.hod_status
                                    ? indent?.hod_status
                                    : "-"}
                                </td>
                                <td
                                  className={
                                    indent?.director_status === "approved"
                                      ? "till-active"
                                      : "not-active-wait" &&
                                        indent?.director_status === "rejected"
                                        ? "not-active"
                                        : "not-active-wait"
                                  }
                                >
                                  {indent?.director_status
                                    ? indent?.director_status
                                    : "-"}
                                </td>
                                <td className="viewoption">
                                  <Link
                                    to={`/app/Indent/IndentSpecificView/${indent?.id}`}
                                  >
                                    View
                                  </Link>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <div> No Data Found</div>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        )}
                      </tbody>
                    )}
                    {active === 1 && (
                      <tbody>
                        {partialapprovedIndentLength > 0 ? (
                          indentList &&
                          indentList
                            ?.filter(
                              (indentList) =>
                                indentList.status === "partially_approved"
                            )
                            .map((indent, index) => (
                              <tr key={index}>
                                <td>
                                  {indent?.indent_number
                                    ? indent?.indent_number
                                    : "-"}
                                </td>
                                <td>
                                  {indent?.employee_name
                                    ? indent?.employee_name
                                    : "-"}
                                </td>
                                <td>
                                  {indent?.department
                                    ? indent?.department
                                    : "-"}
                                </td>
                                <td>
                                  {moment(indent?.requested_date).format(
                                    "DD MMM YY"
                                  )}
                                </td>
                                <td
                                  className={
                                    indent?.hod_status === "approved"
                                      ? "till-active"
                                      : "not-active-wait" &&
                                        indent?.hod_status === "rejected"
                                        ? "not-active"
                                        : "not-active-wait"
                                  }
                                >
                                  {indent?.hod_status
                                    ? indent?.hod_status
                                    : "-"}
                                </td>
                                <td
                                  className={
                                    indent?.director_status === "approved"
                                      ? "till-active"
                                      : "not-active-wait" &&
                                        indent?.director_status === "rejected"
                                        ? "not-active"
                                        : "not-active-wait"
                                  }
                                >
                                  {indent?.director_status ===
                                    "partially_approved"
                                    ? indent?.director_status?.replace(
                                      /_/g,
                                      " "
                                    )
                                    : indent?.director_status}
                                </td>
                                <td className="viewoption">
                                  <Link
                                    to={`/app/Indent/IndentSpecificView/${indent?.id}`}
                                  >
                                    View
                                  </Link>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <div> No Data Found</div>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        )}
                      </tbody>
                    )}
                    {active === 2 && (
                      <tbody>
                        {approvedIndentLength > 0 ? (
                          indentList &&
                          indentList
                            ?.filter(
                              (indentList) => indentList?.status === "approved"
                            )
                            .map((indent, index) => (
                              <tr key={index}>
                                <td>
                                  {indent?.indent_number
                                    ? indent?.indent_number
                                    : "-"}
                                </td>
                                <td>
                                  {indent?.employee_name
                                    ? indent?.employee_name
                                    : "-"}
                                </td>
                                <td>
                                  {indent?.department
                                    ? indent?.department
                                    : "-"}
                                </td>
                                <td>
                                  {moment(indent?.requested_date).format(
                                    "DD MMM YY"
                                  )}
                                </td>
                                <td
                                  className={
                                    indent?.hod_status === "approved"
                                      ? "till-active"
                                      : "not-active-wait" &&
                                        indent?.hod_status === "rejected"
                                        ? "not-active"
                                        : "not-active-wait"
                                  }
                                >
                                  {indent?.hod_status
                                    ? indent?.hod_status
                                    : "-"}
                                </td>
                                <td
                                  className={
                                    indent?.director_status === "approved"
                                      ? "till-active"
                                      : "not-active-wait" &&
                                        indent?.director_status === "rejected"
                                        ? "not-active"
                                        : "not-active-wait"
                                  }
                                >
                                  {indent?.director_status
                                    ? indent?.director_status
                                    : "-"}
                                </td>
                                <td className="viewoption">
                                  <Link
                                    to={`/app/Indent/IndentSpecificView/${indent?.id}`}
                                  >
                                    View
                                  </Link>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <div> No Data Found</div>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        )}
                      </tbody>
                    )}
                    {active === 3 && (
                      <tbody>
                        {rejectedIndentLength > 0 ? (
                          indentList &&
                          indentList
                            ?.filter(
                              (indentList) => indentList?.status === "rejected"
                            )
                            .map((indent, index) => (
                              <tr key={index}>
                                <td>
                                  {indent?.indent_number
                                    ? indent?.indent_number
                                    : "-"}
                                </td>
                                <td>
                                  {indent?.employee_name
                                    ? indent?.employee_name
                                    : "-"}
                                </td>
                                <td>
                                  {indent?.department
                                    ? indent?.department
                                    : "-"}
                                </td>
                                <td>
                                  {moment(indent?.requested_date).format(
                                    "DD MMM YY"
                                  )}
                                </td>
                                <td
                                  className={
                                    indent?.hod_status === "approved"
                                      ? "till-active"
                                      : "not-active-wait" &&
                                        indent?.hod_status === "rejected"
                                        ? "not-active"
                                        : "not-active-wait"
                                  }
                                >
                                  {indent?.hod_status
                                    ? indent?.hod_status
                                    : "-"}
                                </td>
                                <td
                                  className={
                                    indent?.director_status === "approved"
                                      ? "till-active"
                                      : "not-active-wait" &&
                                        indent?.director_status === "rejected"
                                        ? "not-active"
                                        : "not-active-wait"
                                  }
                                >
                                  {indent?.director_status
                                    ? indent?.director_status
                                    : "-"}
                                </td>
                                <td className="viewoption">
                                  <Link
                                    to={`/app/Indent/IndentSpecificView/${indent?.id}`}
                                  >
                                    View
                                  </Link>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <div> No Data Found</div>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        )}
                      </tbody>
                    )}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default IndentApplication;
